import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const MuiRadio: {
    defaultProps?: ComponentsProps['MuiRadio'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiRadio'];
    variants?: ComponentsVariants['MuiRadio'];
} = {
    defaultProps: {
        disableRipple: true,
        size: 'medium',
        color: 'secondary',
    },
    styleOverrides: {},
    variants: [
        {
            props: { size: 'medium' },
            style: { height: '2rem', width: '2rem' },
        },
    ],
};
